import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import PageLoader from "components/common/PageLoader";
import Document from "components/common/Document";
import { AlertType } from "components/common/Snackbar";
import DocumentList from "components/Widgets/BambooHRTabs/Documents/DocumentList/DocumentList";
import NoDocumentScreen from "components/Widgets/BambooHRTabs/Documents/NoDocumentScreen/NoDocumentScreen";

import { showSnackbar } from "store/actions/Utility";
import { DropdownData } from "store/actions/DropdownData";

import { getEmployeeDocumentCount } from "services/BambooHrTabs/documents";

import "./Document.scss";

function EmployeeDocs({ noPadding = false }) {
  const dispatch = useDispatch();
  const params = useParams();

  const documentTypes = useSelector((state) => state.DropdownData?.dropdownData?.payload?.documentTypes || []);

  const [isLoading, setIsLoading] = useState(false);
  const [folders, setFolders] = useState([]);
  const [folderName, setFolderName] = useState();
  const [folderDetailScreen, setFolderDetailScreen] = useState(false);

  const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));

  const loggedInUserType = loggedInUser?.type;
  const employeeId = loggedInUserType === "employee" ? loggedInUser?.userId : params?.id;

  const getEmployeeDocument = async () => {
    try {
      setIsLoading(true);
      const count = await getEmployeeDocumentCount(employeeId);
      if (loggedInUserType == "edge") {
        setFolders(count);
      } else {
        setFolders(count.filter((folder) => folder.count > 0));
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          type: AlertType.error,
          message: error?.message,
          dispatch,
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackClicked = () => {
    setFolderDetailScreen(false);
    setFolderName();
  };

  useEffect(() => {
    getEmployeeDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, employeeId]);

  useEffect(() => {
    if (documentTypes.length === 0) {
      dispatch(DropdownData());
    }
  }, [dispatch, documentTypes.length]);

  return (
    <div className={!noPadding && "pt-175 pb-15 documents-container"}>
      {isLoading && <PageLoader />}
      <div className="flex">
        {folders.length < 1 && loggedInUserType !== "edge" ? (
          <div className="w-full">
            <NoDocumentScreen />
          </div>
        ) : (
          // eslint-disable-next-line react/jsx-no-useless-fragment
          <>
            {folderDetailScreen ? (
              <DocumentList
                noPadding={noPadding}
                loggedInUserType={loggedInUserType}
                documentType={folderName}
                setDocumentType={setFolderName}
                employeeId={employeeId}
                onBackClicked={() => {
                  handleBackClicked();
                  getEmployeeDocument();
                }}
              />
            ) : (
              <div className={!noPadding && "pl-2"}>
                <p className="heading-h4-semibold">Documents</p>
                <div className="flex flex-wrap">
                  {folders?.map((folder) => (
                    <div
                      key={folder.Document_Type}
                      className="mt-1 mr-1"
                      onClick={() => {
                        setFolderName(folder?.Document_Type);
                        setFolderDetailScreen(true);
                      }}
                    >
                      <Document
                        title={folder?.Document_Type}
                        primaryInfo={`${folder?.count} ${folder?.count <= 1 ? "document" : "documents"}`}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default EmployeeDocs;
